// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ti-2";
export var chatLink = "_ti-0";
export var chatText = "_ti-1";